module.exports = __webpack_public_path__ + "static/media/tools-video.86d8b588.svg";